var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { ApiClient } from '../api/apiClient';
import { trackGetYourOffer } from '../utils/analytics';
var MiniRegoForm = function (_a) {
    var _b = _a.redirectUrl, redirectUrl = _b === void 0 ? '' : _b, _c = _a.buttonText, buttonText = _c === void 0 ? 'Get Your Offer' : _c, _d = _a.title, title = _d === void 0 ? '' : _d, _e = _a.states, states = _e === void 0 ? [] : _e;
    var _f = useState(''), rego = _f[0], setRego = _f[1];
    var _g = useState(''), state = _g[0], setState = _g[1];
    var _h = useState(false), isLoading = _h[0], setIsLoading = _h[1];
    var _j = useState(''), error = _j[0], setError = _j[1];
    var _k = useState(false), isSubmitted = _k[0], setIsSubmitted = _k[1];
    var _l = useState(false), isRedirecting = _l[0], setIsRedirecting = _l[1];
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var selectedState, stateName, stateCode, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    // Basic validation
                    if (!rego || !state) {
                        setError('Please enter valid registration and state');
                        return [2 /*return*/];
                    }
                    setError('');
                    setIsLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    selectedState = states.find(function (stateOption) { return String(stateOption.StateId) === String(state); });
                    stateName = selectedState ? selectedState.StateName : '';
                    stateCode = selectedState ? selectedState.StateCode : '';
                    return [4 /*yield*/, ApiClient.submitMiniForm(rego, state, stateName, stateCode)];
                case 2:
                    response = _a.sent();
                    if (!response.success) {
                        throw new Error(response.error || 'There was an error processing your request');
                    }
                    // Track successful form submission (Step 0.5)
                    trackGetYourOffer();
                    // Mark as submitted (but only show success message if not redirecting)
                    setIsSubmitted(true);
                    // If we have a redirect URL, set redirecting state and redirect
                    if (redirectUrl) {
                        setIsRedirecting(true);
                        setTimeout(function () {
                            // Append auto-advance flag so main form can auto-submit step 1
                            var hasQuery = redirectUrl.includes('?');
                            var separator = hasQuery ? '&' : '?';
                            var autoUrl = "".concat(redirectUrl).concat(separator, "tiof_auto=1");
                            window.location.href = autoUrl;
                        }, 300); // Shorter delay, don't show success message
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    setError(error_1 instanceof Error ? error_1.message : 'An unexpected error occurred');
                    setIsLoading(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsx("div", { className: "tiof-mini-form-wrapper", children: (!isSubmitted || isRedirecting) ? (_jsx("form", { id: "tiof-mini-form", method: "post", onSubmit: handleSubmit, children: _jsxs("div", { className: "tiof-mini-form-fields", children: [title && _jsx("h3", { className: "tiof-mini-form-title", children: title }), _jsx("div", { className: "tiof-mini-form-field", children: _jsx("input", { type: "text", id: "vehicle_rego", name: "vehicle_rego", value: rego, onChange: function (e) { return setRego(e.target.value); }, required: true, placeholder: "Enter rego", disabled: isLoading }) }), _jsx("div", { className: "tiof-mini-form-field", children: _jsxs("select", { id: "vehicle_state", name: "vehicle_state", value: state, onChange: function (e) { return setState(e.target.value); }, required: true, disabled: isLoading, children: [_jsx("option", { value: "", children: "Select State" }), states.map(function (state) { return (_jsx("option", { value: state.StateId, children: state.StateCode }, state.StateId)); })] }) }), _jsx("div", { className: "tiof-mini-form-field", children: _jsx("button", { type: "submit", className: "tiof-mini-form-button ".concat(isLoading ? 'loading' : ''), disabled: isLoading, children: isLoading ? 'Loading...' : buttonText }) }), error && _jsx("div", { id: "tiof-mini-form-error", className: "tiof-mini-form-error", children: error })] }) })) : (
        // This will only show if submitted AND not redirecting
        _jsxs("div", { className: "tiof-mini-form-success", children: [_jsx("h3", { children: "Thank You!" }), _jsx("p", { children: "Your vehicle details have been saved." })] })) }));
};
export default MiniRegoForm;
